import { green } from '@mui/material/colors';

const styling = {
    filters: {
        position: 'absolute',
        top: 40,
        zIndex: 1,
        border: '1px solid',
        width: '55em',
        height: '35em',
        borderRadius: '10px',
        bgcolor: 'background.paper',
        display: 'flex',
        flexDirection: 'column',
    },
    exitFilters: {
        alignSelf: 'end',
        appearance: 'none',
        background: 'none',
        border: 'none',
        position: 'absolute',
        margin: '5px',
        cursor: 'pointer',
        transition: 'transform 0.2s ease-in-out', 
        '&:hover': {
            transform: 'scale(1.2)', 
        }
    },
    filterContainer: {
        height: '90%',
        borderRadius: '8px',
        display: 'flex',
    },
    filterSection: {
        flex: '1',
        display: 'flex',
        flexDirection: 'column',
        paddingTop: '30px',
        gap: '15px',
        backgroundColor: '#f4fae8',
        borderRadius: '8px 0 0 0',
    },
    secondFilterSection: {
        flex: '1.25',
        display: 'flex',
        flexDirection: 'column',
        gap: '15px',
        paddingTop: '30px',
        backgroundColor: '#fafff0'
    },
    thirdFilterSection: {
        flex: '1.25',
        padding: '10px',
        paddingTop: '30px',
        backgroundColor: '#f8faf5',
        borderRadius: '0 8px 0 0',
        color: '#263327',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between'
    },
    applyFilter: {
        margin: '10px',
        padding: '5px',
        borderRadius: '8px',
    },
    filterButtons: {
        display: 'flex',
        justifyContent: 'space-between',
        paddingLeft: '20px',
        paddingRight: '10px',
        backgroundColor: '#fffffa',
        borderRadius: '0 0 8px 8px'
    },
    radioButtonStyling: { 
        color: green[900],
        '&.Mui-checked': {
            color: green[800],
        } 
    },
    formLabel: {
        fontSize: '20px',
        color: '#1e3020',
        '&.Mui-focused': {
        color: '#1e5924', 
        }
    },
    radioGroup: {
        padding: '10px'
    },
    dividerColor: {
        background: '#acc2af'
    },
    tag: {
        marginTop: '5px',
        marginLeft: '20px',
        backgroundColor: 'pink'
    },
    listener: {
        position: 'relative'
    },
    customChip: {
        display: 'flex',
        border: `${green[800]} 3px solid`,
        borderRadius: '16px',
        marginLeft: '10px',
        marginTop: '2px',
    },
    chipQuestion: {
        backgroundColor: green[700],
        color: 'white',
        padding: '5px',
        borderRadius: '10px 0 0 10px'
    },
    chipOption: {
        backgroundColor: 'transparent',
        padding: '5px'
    }
};

export default styling;